/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { SlicedDataSource } from '@gh/core-data';
import { SupplierUserContext } from '@gh/supplier-shared';
import { SupplierSharedDocsRestService } from '@gh/supplier-shared-data';
import { SharedDocsModel } from '../models';

@Injectable()
export class SupplierSharedDocsListBusinessService {
  constructor(
    private userContext: SupplierUserContext,
    private restService: SupplierSharedDocsRestService,
  ) {
  }

  getAll(): SlicedDataSource<SharedDocsModel> {
    return this.restService.getAll();
  }
}
